class Celebrations {
	getData = async companyId => {
		const response = await fetch(`${process.env.REACT_APP_API}/company/celebration-emails/${companyId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		return response.json()
	}

	sendData = async data => {
		const response = await fetch(`${process.env.REACT_APP_API}/company/celebration-emails`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return response.json()
	}
}

export default new Celebrations()
